import script from "./ReleaseEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseEntry.vue?vue&type=script&setup=true&lang=js"

import "./ReleaseEntry.vue?vue&type=style&index=0&id=6778abe5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6778abe5"]])

export default __exports__